export default __webpack_public_path__ + "static/media/hht2_ep9_speaking_04.e73cab2b.png";